"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slot = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
/** 用于 `<Trans>` 中插值 */
function Slot(_a) {
    var content = _a.content;
    return react_1.default.createElement(react_1.default.Fragment, null, content);
}
exports.Slot = Slot;
exports.default = Slot;
//# sourceMappingURL=slot.js.map